/**
 * Choice-point overlay (§5.5): three products over the paused game with a
 * visible countdown. The pick is a SIM INPUT (choice bits on the next tick) —
 * this overlay only forwards the tap. Decision speed is captured by the sim.
 */

import type { ChoicePoint } from '@hnplay/shared';

export interface ProductInfo {
  id: string;
  name: string;
  imageUrl?: string | null | undefined;
  storeUrl?: string | null | undefined;
  addToCartUrl?: string | null | undefined;
}

export function showChoiceOverlay(
  overlay: HTMLElement,
  cp: ChoicePoint,
  products: Map<string, ProductInfo>,
  onPick: (n: number) => void,
): () => void {
  const el = document.createElement('div');
  el.className = 'hnp-choice';
  const seconds = Math.ceil(cp.timeoutTicks / 60);
  el.innerHTML = `
    <div class="hnp-choice__panel">
      <p class="hnp-choice__title">Pick a catalyst</p>
      <div class="hnp-choice__options"></div>
      <div class="hnp-choice__timer"><span style="animation-duration:${seconds}s"></span></div>
    </div>`;
  const options = el.querySelector('.hnp-choice__options') as HTMLElement;

  cp.offeredIds.forEach((id, idx) => {
    const info = products.get(id) ?? { id, name: id };
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'hnp-choice__opt';
    btn.innerHTML = `
      ${info.imageUrl ? `<img src="${info.imageUrl}" alt="" loading="eager">` : '<span class="hnp-choice__swatch"></span>'}
      <span class="hnp-choice__name">${info.name}</span>`;
    btn.addEventListener('click', () => {
      onPick(idx + 1);
      for (const b of options.querySelectorAll('button')) (b as HTMLButtonElement).disabled = true;
      btn.classList.add('hnp-choice__opt--picked');
    });
    options.appendChild(btn);
  });

  overlay.appendChild(el);
  return () => el.remove();
}
